import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import TopUpSlider from '../pages/account/components/TopUpSlider'
import { registerTopUpOpener } from '../utils/topUpRequest'

/**
 * Окно «Докупить токены» из плашек нехватки — одна копия в App (utils/topUpRequest): живёт отдельно от кнопки, которая
 * его открыла, — та исчезает, как только баланса хватает, а окно с «Оплата получена» остаётся до «Готово». Слой
 * .credits-short__layer — над шторками (плашки живут и внутри них). После оплаты окно само сверяет баланс и не уводит
 * в кабинет (stayOnPage).
 */
export default function TopUpHost() {
	// null — закрыто; число — сколько токенов подставить (0 — сумма по умолчанию из админки)
	const [need, setNeed] = useState<number | null>(null)

	useEffect(() => {
		registerTopUpOpener((n) => setNeed(n))
		return () => registerTopUpOpener(null)
	}, [])

	if (need === null) return null
	return createPortal(
		<div className="credits-short__layer"><TopUpSlider open stayOnPage needTokens={need} onClose={() => setNeed(null)} /></div>,
		document.body,
	)
}
